export default{
  install(Vue,options) {
    Vue.prototype.NoticeUtils = function (response) {
      if(response.data.code == '1'){
        this.$Notice.success({
          desc: response.data.message
        });
      }else if(response.data.code == '0'){
        this.$Notice.warning({
          desc: response.data.message
        });
      }else{
        this.$Notice.error({
          desc: response.data.message
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/NoticeUtils.js